var map = {
	"./AGoodNewsStoryFromPeddie": [
		359,
		58
	],
	"./AGoodNewsStoryFromPeddie.js": [
		359,
		58
	],
	"./AdviceFromTheExpertsPart10": [
		366,
		59
	],
	"./AdviceFromTheExpertsPart10.js": [
		366,
		59
	],
	"./AdviceFromTheExpertsPart11": [
		367,
		60
	],
	"./AdviceFromTheExpertsPart11.js": [
		367,
		60
	],
	"./AdviceFromTheExpertsPart5": [
		281,
		49
	],
	"./AdviceFromTheExpertsPart5.js": [
		281,
		49
	],
	"./AdviceFromTheExpertsPart6": [
		368,
		61
	],
	"./AdviceFromTheExpertsPart6.js": [
		368,
		61
	],
	"./AdviceFromTheExpertsPart7": [
		369,
		62
	],
	"./AdviceFromTheExpertsPart7.js": [
		369,
		62
	],
	"./AdviceFromTheExpertsPart8": [
		370,
		63
	],
	"./AdviceFromTheExpertsPart8.js": [
		370,
		63
	],
	"./AdviceFromTheExpertsPart9": [
		371,
		64
	],
	"./AdviceFromTheExpertsPart9.js": [
		371,
		64
	],
	"./AdviceFromTheExpertsTenantsPart1": [
		282,
		50
	],
	"./AdviceFromTheExpertsTenantsPart1.js": [
		282,
		50
	],
	"./AdviceFromTheExpertsTenantsPart2": [
		283,
		51
	],
	"./AdviceFromTheExpertsTenantsPart2.js": [
		283,
		51
	],
	"./AlternativeEnergyInstallations": [
		360,
		65
	],
	"./AlternativeEnergyInstallations.js": [
		360,
		65
	],
	"./AreGardensOwnedByUnitOwners": [
		284,
		66
	],
	"./AreGardensOwnedByUnitOwners.js": [
		284,
		66
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair": [
		285,
		67
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair.js": [
		285,
		67
	],
	"./CIAGeyserEmergencyAssist": [
		361,
		68
	],
	"./CIAGeyserEmergencyAssist.js": [
		361,
		68
	],
	"./CIAPrivacyPolicy": [
		372,
		14
	],
	"./CIAPrivacyPolicy.js": [
		372,
		14
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers": [
		286,
		69
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers.js": [
		286,
		69
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2": [
		287,
		70
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2.js": [
		287,
		70
	],
	"./CiaIssuesPolicy": [
		288,
		52
	],
	"./CiaIssuesPolicy.js": [
		288,
		52
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining": [
		373,
		71
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining.js": [
		373,
		71
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount": [
		289,
		53
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount.js": [
		289,
		53
	],
	"./CommonPropertyPart1": [
		374,
		72
	],
	"./CommonPropertyPart1.js": [
		374,
		72
	],
	"./CommonPropertyPart2": [
		375,
		73
	],
	"./CommonPropertyPart2.js": [
		375,
		73
	],
	"./CommonPropertyPart3": [
		376,
		74
	],
	"./CommonPropertyPart3.js": [
		376,
		74
	],
	"./CommonPropertyPart4": [
		377,
		75
	],
	"./CommonPropertyPart4.js": [
		377,
		75
	],
	"./CommonPropertyPart5": [
		378,
		76
	],
	"./CommonPropertyPart5.js": [
		378,
		76
	],
	"./CommunitySchemesTraining": [
		379,
		77
	],
	"./CommunitySchemesTraining.js": [
		379,
		77
	],
	"./ComputeCrimeClaimsPart2": [
		290,
		78
	],
	"./ComputeCrimeClaimsPart2.js": [
		290,
		78
	],
	"./ComputeCrimeClaimsPart3": [
		291,
		79
	],
	"./ComputeCrimeClaimsPart3.js": [
		291,
		79
	],
	"./ComputerCrimePolicyWordingChanges": [
		292,
		80
	],
	"./ComputerCrimePolicyWordingChanges.js": [
		292,
		80
	],
	"./ComputerCrimePolicyWordingChanges1": [
		380,
		81
	],
	"./ComputerCrimePolicyWordingChanges1.js": [
		380,
		81
	],
	"./ComputerCrimeWordingProposalFormPart1": [
		293,
		82
	],
	"./ComputerCrimeWordingProposalFormPart1.js": [
		293,
		82
	],
	"./DealingWithABodyCorporateClaim": [
		294,
		83
	],
	"./DealingWithABodyCorporateClaim.js": [
		294,
		83
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection": [
		295,
		84
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection.js": [
		295,
		84
	],
	"./DidYouKnowPart1": [
		381,
		85
	],
	"./DidYouKnowPart1.js": [
		381,
		85
	],
	"./DidYouKnowPart2": [
		296,
		54
	],
	"./DidYouKnowPart2.js": [
		296,
		54
	],
	"./DidYouKnowPart3": [
		297,
		55
	],
	"./DidYouKnowPart3.js": [
		297,
		55
	],
	"./DidYouKnowPart4": [
		382,
		6
	],
	"./DidYouKnowPart4.js": [
		382,
		6
	],
	"./DidYouKnowPart5": [
		383,
		7
	],
	"./DidYouKnowPart5.js": [
		383,
		7
	],
	"./DidYouKnowPart6": [
		384,
		8
	],
	"./DidYouKnowPart6.js": [
		384,
		8
	],
	"./EmployersLiability": [
		298,
		86
	],
	"./EmployersLiability.js": [
		298,
		86
	],
	"./EnforcementOfRulesPart1": [
		385,
		15
	],
	"./EnforcementOfRulesPart1.js": [
		385,
		15
	],
	"./EnforcementOfRulesPart2": [
		386,
		16
	],
	"./EnforcementOfRulesPart2.js": [
		386,
		16
	],
	"./EnforcementOfRulesPart4": [
		387,
		17
	],
	"./EnforcementOfRulesPart4.js": [
		387,
		17
	],
	"./EnforecmentOfRulesPart3": [
		388,
		18
	],
	"./EnforecmentOfRulesPart3.js": [
		388,
		18
	],
	"./EnvironmentalUpgradeForGeysers": [
		299,
		87
	],
	"./EnvironmentalUpgradeForGeysers.js": [
		299,
		87
	],
	"./ExamplesOfCxtraCoverFollowingDamage": [
		300,
		88
	],
	"./ExamplesOfCxtraCoverFollowingDamage.js": [
		300,
		88
	],
	"./FidelityFundCertificatesAndCreditChecks": [
		301,
		89
	],
	"./FidelityFundCertificatesAndCreditChecks.js": [
		301,
		89
	],
	"./FireRiskManagementTipsProtectionAgainstFire": [
		302,
		90
	],
	"./FireRiskManagementTipsProtectionAgainstFire.js": [
		302,
		90
	],
	"./FireWisePart1": [
		389,
		91
	],
	"./FireWisePart1.js": [
		389,
		91
	],
	"./FireWisePart10": [
		390,
		92
	],
	"./FireWisePart10.js": [
		390,
		92
	],
	"./FireWisePart11": [
		391,
		93
	],
	"./FireWisePart11.js": [
		391,
		93
	],
	"./FireWisePart12": [
		362,
		94
	],
	"./FireWisePart12.js": [
		362,
		94
	],
	"./FireWisePart13": [
		303,
		95
	],
	"./FireWisePart13.js": [
		303,
		95
	],
	"./FireWisePart14": [
		304,
		96
	],
	"./FireWisePart14.js": [
		304,
		96
	],
	"./FireWisePart15": [
		305,
		0,
		135
	],
	"./FireWisePart15.js": [
		305,
		0,
		135
	],
	"./FireWisePart16": [
		306,
		97
	],
	"./FireWisePart16.js": [
		306,
		97
	],
	"./FireWisePart17": [
		307,
		98
	],
	"./FireWisePart17.js": [
		307,
		98
	],
	"./FireWisePart18": [
		308,
		99
	],
	"./FireWisePart18.js": [
		308,
		99
	],
	"./FireWisePart19": [
		309,
		100
	],
	"./FireWisePart19.js": [
		309,
		100
	],
	"./FireWisePart2": [
		310,
		0,
		133
	],
	"./FireWisePart2.js": [
		310,
		0,
		133
	],
	"./FireWisePart3": [
		311,
		0,
		134
	],
	"./FireWisePart3.js": [
		311,
		0,
		134
	],
	"./FireWisePart4": [
		363,
		101
	],
	"./FireWisePart4.js": [
		363,
		101
	],
	"./FireWisePart6": [
		392,
		102
	],
	"./FireWisePart6.js": [
		392,
		102
	],
	"./FireWisePart7": [
		393,
		103
	],
	"./FireWisePart7.js": [
		393,
		103
	],
	"./FireWisePart8": [
		394,
		104
	],
	"./FireWisePart8.js": [
		394,
		104
	],
	"./FireWisePart9": [
		395,
		105
	],
	"./FireWisePart9.js": [
		395,
		105
	],
	"./FloodRiskManagementTips": [
		312,
		106
	],
	"./FloodRiskManagementTips.js": [
		312,
		106
	],
	"./GeneralConditionsAndProvisions": [
		313,
		107
	],
	"./GeneralConditionsAndProvisions.js": [
		313,
		107
	],
	"./GeneratorPart2": [
		314,
		2
	],
	"./GeneratorPart2.js": [
		314,
		2
	],
	"./GeneratorPart3": [
		315,
		3
	],
	"./GeneratorPart3.js": [
		315,
		3
	],
	"./GeneratorPart4": [
		396,
		19
	],
	"./GeneratorPart4.js": [
		396,
		19
	],
	"./Generators": [
		397,
		20
	],
	"./Generators.js": [
		397,
		20
	],
	"./GeneratorsAndSolarSystems": [
		398,
		108
	],
	"./GeneratorsAndSolarSystems.js": [
		398,
		108
	],
	"./GuidelinesToProtectingYourVacantProperty": [
		316,
		109
	],
	"./GuidelinesToProtectingYourVacantProperty.js": [
		316,
		109
	],
	"./HeavyRainAndFlooding": [
		399,
		9
	],
	"./HeavyRainAndFlooding.js": [
		399,
		9
	],
	"./KZNFlooding": [
		400,
		21
	],
	"./KZNFlooding.js": [
		400,
		21
	],
	"./KeyInformationDocuments": [
		317,
		110
	],
	"./KeyInformationDocuments.js": [
		317,
		110
	],
	"./LayoutOfCiaWording": [
		318,
		111
	],
	"./LayoutOfCiaWording.js": [
		318,
		111
	],
	"./LegislativeRequirementsForCommunitySchemesPart1": [
		319,
		112
	],
	"./LegislativeRequirementsForCommunitySchemesPart1.js": [
		319,
		112
	],
	"./LegislativeRequirementsForCommunitySchemesPart2": [
		320,
		113
	],
	"./LegislativeRequirementsForCommunitySchemesPart2.js": [
		320,
		113
	],
	"./LetsPlayActivityBook": [
		321,
		114
	],
	"./LetsPlayActivityBook.js": [
		321,
		114
	],
	"./LiabilityClaimsMadeVsLossesOccurring": [
		322,
		115
	],
	"./LiabilityClaimsMadeVsLossesOccurring.js": [
		322,
		115
	],
	"./LithiumBatteryFiresPart2": [
		323,
		116
	],
	"./LithiumBatteryFiresPart2.js": [
		323,
		116
	],
	"./LithiumBetteryFires": [
		364,
		117
	],
	"./LithiumBetteryFires.js": [
		364,
		117
	],
	"./LoavesForMandelaDayUpdate": [
		401,
		118
	],
	"./LoavesForMandelaDayUpdate.js": [
		401,
		118
	],
	"./MachineryBreakdown": [
		324,
		119
	],
	"./MachineryBreakdown.js": [
		324,
		119
	],
	"./MessageFromSasriasManagingDirector": [
		325,
		4
	],
	"./MessageFromSasriasManagingDirector.js": [
		325,
		4
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy": [
		326,
		120
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy.js": [
		326,
		120
	],
	"./NewCpdApprovedTraining": [
		327,
		121
	],
	"./NewCpdApprovedTraining.js": [
		327,
		121
	],
	"./NewsletterSubscriberPOPIACompliance": [
		328,
		22
	],
	"./NewsletterSubscriberPOPIACompliance.js": [
		328,
		22
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers": [
		329,
		122
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers.js": [
		329,
		122
	],
	"./OvercrowdingPart1": [
		402,
		23
	],
	"./OvercrowdingPart1.js": [
		402,
		23
	],
	"./OvercrowdingPart2": [
		403,
		24
	],
	"./OvercrowdingPart2.js": [
		403,
		24
	],
	"./PersonalAccident": [
		330,
		123
	],
	"./PersonalAccident.js": [
		330,
		123
	],
	"./ProtectingVacantPropertyPart1": [
		331,
		124
	],
	"./ProtectingVacantPropertyPart1.js": [
		331,
		124
	],
	"./ProtectingVacantPropertyPart3": [
		332,
		125
	],
	"./ProtectingVacantPropertyPart3.js": [
		332,
		125
	],
	"./ProtectingVacantPropertyPart4": [
		333,
		126
	],
	"./ProtectingVacantPropertyPart4.js": [
		333,
		126
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance": [
		334,
		127
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance.js": [
		334,
		127
	],
	"./RisingDamp": [
		335,
		56
	],
	"./RisingDamp.js": [
		335,
		56
	],
	"./RisingDampPart2": [
		336,
		57
	],
	"./RisingDampPart2.js": [
		336,
		57
	],
	"./SadNewsFromCIA": [
		404,
		25
	],
	"./SadNewsFromCIA.js": [
		404,
		25
	],
	"./SasriaClaims": [
		405,
		26
	],
	"./SasriaClaims.js": [
		405,
		26
	],
	"./SasriaRateIncrease1January2022": [
		337,
		5
	],
	"./SasriaRateIncrease1January2022.js": [
		337,
		5
	],
	"./SasriaRateIncrease2025": [
		406,
		1
	],
	"./SasriaRateIncrease2025.js": [
		406,
		1
	],
	"./The10YearPlanPart1": [
		407,
		27
	],
	"./The10YearPlanPart1.js": [
		407,
		27
	],
	"./The10YearPlanPart2": [
		338,
		28
	],
	"./The10YearPlanPart2.js": [
		338,
		28
	],
	"./The10YearPlanPart3": [
		365,
		29
	],
	"./The10YearPlanPart3.js": [
		365,
		29
	],
	"./The10YearPlanPart4": [
		408,
		30
	],
	"./The10YearPlanPart4.js": [
		408,
		30
	],
	"./TheDevastationOfLithium": [
		358,
		128
	],
	"./TheDevastationOfLithium.js": [
		358,
		128
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies": [
		339,
		129
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies.js": [
		339,
		129
	],
	"./TheftAndCrimeRiskManagement": [
		340,
		130
	],
	"./TheftAndCrimeRiskManagement.js": [
		340,
		130
	],
	"./TrusteesIndemnity": [
		341,
		31
	],
	"./TrusteesIndemnity.js": [
		341,
		31
	],
	"./UnderstandingLiabilityClaimsPart1": [
		409,
		10
	],
	"./UnderstandingLiabilityClaimsPart1.js": [
		409,
		10
	],
	"./UnderstandingLiabilityClaimsPart2": [
		410,
		131
	],
	"./UnderstandingLiabilityClaimsPart2.js": [
		410,
		131
	],
	"./UnderstandingLiabilityClaimsPart3": [
		411,
		11
	],
	"./UnderstandingLiabilityClaimsPart3.js": [
		411,
		11
	],
	"./UnderstandingLiabilityClaimsPart4": [
		412,
		12
	],
	"./UnderstandingLiabilityClaimsPart4.js": [
		412,
		12
	],
	"./UnderstandingLiabilityClaimsPart5": [
		413,
		13
	],
	"./UnderstandingLiabilityClaimsPart5.js": [
		413,
		13
	],
	"./ValidityOfClaims": [
		342,
		32
	],
	"./ValidityOfClaims.js": [
		342,
		32
	],
	"./ValidityOfClaimsPart2": [
		343,
		33
	],
	"./ValidityOfClaimsPart2.js": [
		343,
		33
	],
	"./WaterLeakageTips": [
		344,
		34
	],
	"./WaterLeakageTips.js": [
		344,
		34
	],
	"./WaterproofingAndWaterIngressPart1": [
		414,
		35
	],
	"./WaterproofingAndWaterIngressPart1.js": [
		414,
		35
	],
	"./WaterproofingAndWaterIngressPart2": [
		415,
		36
	],
	"./WaterproofingAndWaterIngressPart2.js": [
		415,
		36
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy": [
		345,
		37
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy.js": [
		345,
		37
	],
	"./WhatAreGeysersCoveredFor": [
		346,
		38
	],
	"./WhatAreGeysersCoveredFor.js": [
		346,
		38
	],
	"./WhatConstitutesAVoluntaryWorker": [
		347,
		39
	],
	"./WhatConstitutesAVoluntaryWorker.js": [
		347,
		39
	],
	"./WhatDamageRiskManagement": [
		348,
		40
	],
	"./WhatDamageRiskManagement.js": [
		348,
		40
	],
	"./WhatIsASpecificExclusion": [
		349,
		41
	],
	"./WhatIsASpecificExclusion.js": [
		349,
		41
	],
	"./WhatIsCoveredUnderExtraCover": [
		350,
		42
	],
	"./WhatIsCoveredUnderExtraCover.js": [
		350,
		42
	],
	"./WhatIsCoveredUnderTheLiabilitySection": [
		351,
		43
	],
	"./WhatIsCoveredUnderTheLiabilitySection.js": [
		351,
		43
	],
	"./WhatIsExtraCoverFollowingDamage": [
		352,
		44
	],
	"./WhatIsExtraCoverFollowingDamage.js": [
		352,
		44
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover": [
		353,
		45
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover.js": [
		353,
		45
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys": [
		354,
		46
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys.js": [
		354,
		46
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery": [
		355,
		47
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery.js": [
		355,
		47
	],
	"./WhenIsALossadjusterAppointed": [
		356,
		48
	],
	"./WhenIsALossadjusterAppointed.js": [
		356,
		48
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires": [
		357,
		132
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires.js": [
		357,
		132
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 256;
module.exports = webpackAsyncContext;